const styles = theme => ({
    footerLi: {
        listStyle: 'none',
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.header.contrastText,
        paddingRight: 5,
    },
    anchor: {
        color: theme.palette.header.contrastText,
        marginRight: theme.spacing(2),
        textDecoration: 'none',
        paddingBottom: 1,
        fontWeight: 400,

        '&:hover': {
            textDecoration: 'underline'
        }
    },
});

export default styles;